var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 14,
    viewBox: "0 0 100 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2476 0V14H14.7756V4.896L11.603 13.984H7.64466L4.47197 4.896V13.984H0V0H6.52667L9.62381 9.2L12.721 0H19.2476Z",
    fill: "#003459"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0743 11.84H25.6836L24.8526 14H20.1843L26.2879 0H31.4549L37.5736 14H32.9052L32.0743 11.84ZM30.8354 8.592L28.8714 3.536L26.9224 8.592H30.8354Z",
    fill: "#003459"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5025 9.456H42.9974V14H38.5255V0H47.9226C51.5637 0 53.573 1.776 53.573 4.64C53.573 6.752 52.5608 8.112 50.8687 8.832L53.9961 13.984H49.1766L46.5025 9.456ZM42.9974 6.256H47.2881C48.6025 6.256 49.0255 5.536 49.0255 4.64C49.0255 3.728 48.4816 3.248 47.2881 3.248H42.9974V6.256Z",
    fill: "#003459"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5092 6.992C70.5092 12.896 66.3243 13.984 62.1847 13.984H55.1292V0H62.1847C66.3243 0 70.5092 1.12 70.5092 6.992ZM65.9919 6.992C65.9919 3.392 63.8617 3.232 61.2027 3.232H59.6163V10.768H61.1876C63.8617 10.768 65.9919 10.608 65.9919 6.992Z",
    fill: "#003459"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5221 0V14H72.035V0H76.5221Z",
    fill: "#003459"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8977 0V14H78.4106V0H82.8977Z",
    fill: "#003459"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100 0V14H95.2561L89.2582 5.68V14H84.7863V0H89.5302L95.5281 8.336V0H100Z",
    fill: "#003459"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/Dark.347514c6ad8b22e8acd1c5fb2e0469ba.svg";
export { ForwardRef as ReactComponent };